import _styled from "@emotion/styled-base";
export var PopUpStyled = _styled("section", {
  target: "e1erpne10"
})({
  name: "quv43y",
  styles: "align-items:center;background-color:rgba(0,0,0,0.8);display:flex;height:100%;justify-content:center;position:fixed;width:100%;z-index:9999;"
});
export var PopUpContainer = _styled("div", {
  target: "e1erpne11"
})({
  name: "13dkxsa",
  styles: "background-color:#fff;box-sizing:border-box;display:flex;flex-direction:column;max-height:90vh;max-width:40em;overflow:auto;padding:5%;width:90vw;@media screen and (min-width:600px){width:60vw;}"
});
export var PopUpContent = _styled("div", {
  target: "e1erpne12"
})({
  name: "owdwae",
  styles: "align-items:center;display:grid;height:100%;width:100%;button{cursor:pointer;margin:1em;}"
});